// extracted by mini-css-extract-plugin
export var numpadContainer = "_of-1";
export var phoneButton = "_of-0";